//#region src/Tooltip/utils.ts
const TOOLTIP_OPEN = "tooltip.open";

//#endregion
export { TOOLTIP_OPEN };
//# sourceMappingURL=utils.js.map